import { render, staticRenderFns } from "./NumberWidget.vue?vue&type=template&id=bad2d142&scoped=true&"
import script from "./NumberWidget.vue?vue&type=script&lang=js&"
export * from "./NumberWidget.vue?vue&type=script&lang=js&"
import style0 from "./NumberWidget.vue?vue&type=style&index=0&id=bad2d142&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad2d142",
  null
  
)

export default component.exports